module.exports = __webpack_public_path__ + "static/media/marriage.03d8a6a1.jpg";